import { User } from '@shared/models';

export class AccessToken {
    accessToken?: string;
    accessTokenExpiration?: Date;

    deserialize(data: any): this {
        this.accessToken = data.access;
        this.accessTokenExpiration = new Date(data.access_expiration);
        return this;
    }
}

export class SessionToken extends AccessToken {
    refreshToken?: string;
    refreshTokenExpiration?: Date;
    user?: User;

    override deserialize(data: any): this {
        super.deserialize(data);
        this.accessToken = data.access;
        this.refreshToken = data.refresh;
        this.refreshTokenExpiration = new Date(data.refresh_expiration);
        this.user = new User().deserialize(data.user);
        return this;
    }
}
